var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"small-boxes flex",staticClass:"small-box-container"},[_c('subscription-box'),_vm._v(" "),_c('card-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }